class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      if(!event.target.hasAttribute('js-ignore-input-field')) {
        this.onSubmitHandler(event);
      }
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.mobileFilterForm = document.querySelector('#FacetFiltersFormMobile')
    if(!this.mobileFilterForm?.querySelectorAll('.active-facets facet-remove').length) {
      this.mobileFilterForm.querySelector('[js-filter-drawer-clear-all]').classList.add('hide')
    } else {
      this.mobileFilterForm.querySelector('[js-filter-drawer-clear-all]').classList.remove('hide')
    }
    document.querySelector('#SortBy-mobile').addEventListener('change', function () {
      document.body.classList.remove('overflow-hidden-mobile')
      const getFilterForm = document.querySelector('menu-drawer.mobile-facets__wrapper');
      if (getFilterForm) {
        getFilterForm.classList.remove("sort-filter-open");
      }
      getFilterForm.querySelector('.mobile-facets__close').click();
    });
   
    let collectionFullUrl = window.location.href;
    if(collectionFullUrl.includes('?filter.') || collectionFullUrl.includes('?limit=')) {
       if(document.querySelector('.meta-robots')) {
        document.querySelector('.meta-robots').setAttribute('content', 'index, nofollow');
       }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static cleanSearchParams(searchParams) {
    const cleaned = new URLSearchParams();
    const seen = new Set();
    new URLSearchParams(searchParams || '').forEach((value, key) => {
      if (value === '' && key.indexOf('filter.') === 0) return;
      const sig = `${key}=${value}`;
      if (seen.has(sig)) return;
      seen.add(sig);
      cleaned.append(key, value);
    });
    return cleaned.toString();
  }

  // ADDED
  static scrollToProductGrid() {
    if (typeof window.scrollToProductGrid === 'function') {
      window.scrollToProductGrid();
      return;
    }
    const grid = document.querySelector('.Collection_product_grid_inner_new') || document.getElementById('ProductGridContainer');
    if (!grid) return;
    const rect = grid.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeader = document.querySelector('.shopify-section-header-sticky') || document.querySelector('header');
    const headerOffset = stickyHeader ? stickyHeader.offsetHeight + 40 : 160;
    const offsetTop = Math.max(0, rect.top + scrollTop - headerOffset);
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = FacetFiltersForm.cleanSearchParams(searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    // ADDED: filter apply/remove par products ke top se dikhao (back/forward par nahi)
    if (updateURLHash) FacetFiltersForm.shouldScrollToTop = true;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .product-grid-container .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    stickyFilter ()
    productCardSwiper ()
  }

  static clearLoadingState() {
    document
      .querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .product-grid-container .loading__spinner'
      )
      .forEach((spinner) => spinner.classList.add('hidden'));
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
    document.getElementById('ProductCount')?.classList.remove('loading');
    document.getElementById('ProductCountDesktop')?.classList.remove('loading');
  }

  static renderSectionFromFetch(url, event) {
    if (FacetFiltersForm.sectionAbort) FacetFiltersForm.sectionAbort.abort();
    const controller = new AbortController();
    FacetFiltersForm.sectionAbort = controller;

    fetch(url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          FacetFiltersForm.clearLoadingState();
          return null;
        }
        return response.text();
      })
      .then((responseText) => {
        if (!responseText) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        if (typeof collectionLoadMore === 'function') collectionLoadMore();
      })
      .catch((error) => {
        if (error && error.name === 'AbortError') return;
        FacetFiltersForm.clearLoadingState();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    // close filter
    const drawerContainer = document.querySelector('.facets-container-drawer')
    if(drawerContainer) {
      const drawerDetailState = drawerContainer.querySelector('.mobile-facets__wrapper > details[open]')
      if(drawerDetailState) {
        drawerDetailState.removeAttribute('open')
        drawerDetailState.classList.remove('menu-opening')
      }
    }
  }

  static renderProductGridContainer(html) {
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const target = document.getElementById('ProductGridContainer');
    if (!source || !target) {
      FacetFiltersForm.clearLoadingState();
      return;
    }
    target.innerHTML = source.innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // ADDED: grid replace hone ke baad top par scroll
    if (FacetFiltersForm.shouldScrollToTop) {
      FacetFiltersForm.shouldScrollToTop = false;
      FacetFiltersForm.scrollToProductGrid();
    }
  }

  static renderProductCount(html) {
    const countEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    if (!countEl || !container) {
      FacetFiltersForm.clearLoadingState();
      return;
    }
    const count = countEl.innerHTML;
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    if (document.body.classList.contains('template--luxe-collection-new') && window.matchMedia('(min-width: 750px) and (max-width: 1024px)').matches) {
      document.body.classList.remove('overflow-hidden-mobile')
    }
    stickyFilter ()
    productCardSwiper ()
    if (typeof updateVisiblePlpProductCount === 'function') updateVisiblePlpProductCount();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
   
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    
     if(document.querySelector('.meta-robots')) {
      if(searchParams.includes('filter.')) {
       
        document.querySelector('.meta-robots').setAttribute('content', 'index, nofollow');
      }
      else {
       
        document.querySelector('.meta-robots').setAttribute('content', 'index, follow');
      }
    }
    
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
    const targetFacets = event.target;
    // const closestDetails = targetFacets.closest('details');
    // if (closestDetails) {
    //   closestDetails.removeAttribute('open');
    // }
    if (document.body.classList.contains('overflow-hidden-mobile')) {
      document.body.classList.remove('overflow-hidden-mobile')
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    const currentFilterState = event.target
    const currentFilterName = currentFilterState.name

    if(currentFilterState && !currentFilterState.checked) {
      const currentFilterInMobileFD = document.querySelector(`#FacetFiltersFormMobile input:checked[name='${currentFilterName}']`)
      if(currentFilterInMobileFD) {
        currentFilterInMobileFD.checked = false
      }
    }
    
    //  if (currentFilterState && currentFilterState.type === 'checkbox') {
    //   const nm = currentFilterState.name;
    //   const vl = currentFilterState.value;
    //   const isChecked = currentFilterState.checked;
    //   document.querySelectorAll(`input[type="checkbox"][name="${nm}"]`).forEach((inp) => {
    //     if (inp !== currentFilterState && inp.value === vl) {
    //       inp.checked = isChecked;
    //     }
    //   });
    // }

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        }  
        if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
        if (form.id === 'FacetFiltersFormcustom') {
          const params = this.createSearchParams(form);
          if (params && params.trim() !== '') {
            for (let i = forms.length - 1; i >= 0; i--) {
              const cleaned = forms[i]
                .split('&')
                .filter(q => !q.startsWith('filter.v.m.custom.delivery_days='))
                .join('&');

              if (cleaned) {
                forms[i] = cleaned;
              } else {
                forms.splice(i, 1);
              }
            }
            forms.push(params);
          }
        }
      });

      if(!isMobile) {
        const sortForm = event.target.closest('#FacetSortForm') ? event.target.closest('#FacetSortForm') : document.querySelector('#FacetSortForm');
        forms.push(this.createSearchParams(sortForm));
      }
      

      const url = new URL(location.href);
      const pagination = url.searchParams.get('limit');
      if(pagination) {
        forms.push(`limit=${pagination}`);
      }
      
        // const cleaned = new URLSearchParams();
        // const seen = new Set();
        // new URLSearchParams(forms.join('&')).forEach((value, key) => {
        //   if (value === '' && key.indexOf('filter.') === 0) return;   // empty price/filter skip
        //   if (key === 'sort_by' && value === 'manual') return;        // default sort skip
        //   const sig = key + '=' + value;
        //   if (seen.has(sig)) return;                                  // duplicate skip
        //   seen.add(sig);
        //   cleaned.append(key, value);
        // });

        // this.onSubmitForm(cleaned.toString(), event);
        this.onSubmitForm(forms.join('&'), event);
    }
    if(window.innerWidth >= 750) {
        const drawerContainer = event.target.closest('.facets-container-drawer')
        if(drawerContainer) {
          const drawerDetailState = drawerContainer.querySelector('.mobile-facets__wrapper details[open]')
          if(drawerDetailState) {
            drawerDetailState.removeAttribute('open')
            drawerDetailState.classList.remove('menu-opening')
          }
        }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    let url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    if (!url) {
      window.location.href = window.location.pathname;
      return;
    }

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.shouldScrollToTop = false; // ADDED
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input');

    this.inputs.forEach((input) => {
      input.addEventListener('change', this.onRangeChange.bind(this));
      input.addEventListener('keydown', this.onKeyDown.bind(this));
      input.addEventListener('focus', (e) => {
        // Track the last focused input
        PriceRange.lastFocusedInput = e.target;
        PriceRange.lastSelectionStart = e.target.selectionStart;
        PriceRange.lastSelectionEnd = e.target.selectionEnd;
      });
    });

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();

    // Restore focus shortly after DOM update (after filter applied)
    setTimeout(() => {
      if (PriceRange.lastFocusedInput && document.body.contains(PriceRange.lastFocusedInput)) {
        PriceRange.lastFocusedInput.focus();
        PriceRange.lastFocusedInput.setSelectionRange(
          PriceRange.lastSelectionStart,
          PriceRange.lastSelectionEnd
        );
      }
    }, 100); // delay may be adjusted
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minInput = this.inputs[0];
    const maxInput = this.inputs[1];

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.closeFilter.bind(this));
this.addEventListener('keyup', (event) => {
  if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
});
  }

  closeFilter(event) {
    event.preventDefault();

    const link = this.querySelector('a');
    if (!link) return;

    const href = link.getAttribute('href');
    const query = href.includes('?') ? href.split('?')[1] : '';

    /* If filters exist → AJAX */
    if (query && query.includes('filter.')) {
      FacetFiltersForm.renderPage(query, event);
    } 
    else {
      /* Last filter removed → clean URL */
      window.location.href = window.location.pathname;
    }

    const detailsElements = document.querySelectorAll(".facets-container details");
    detailsElements.forEach(detail => detail.removeAttribute("open"));

    document.body.classList.remove('overflow-hidden-mobile');
  }
}

customElements.define('facet-remove', FacetRemove);


function stickyFilter () {
  if (!window.matchMedia("(min-width: 1025px)").matches) {
    return;
  }

  const navBar = document.getElementById("sideNav");
  if (!navBar) return;
  
  const header = document.querySelector("header");
  const targetSection = document.querySelector(".Collection_product_grid_inner_new");
  const footer = document.querySelector(".shopify-section-group-footer-group");
  const scrollElm = document.querySelector(".collection_left_new");
  const navBarText = document.getElementById("custom-active-facets");
  const productGrid = document.getElementById("ProductGridContainer");

  if (!header || !targetSection || !footer || !productGrid) {
    return;
  }

  function handleScroll() {
    const navHeight = navBar.getBoundingClientRect().height;
    const productGridHeight = productGrid.getBoundingClientRect().height;
    // ✅ Stop if productGrid is shorter than sidebar
    if (productGridHeight < navHeight) {
      navBar.classList.remove("navScrolled");
      scrollElm?.classList.remove("collection_left_new1");
      navBarText?.classList.remove("filtertitle");
      productGrid?.classList.remove("blokmargin");
      return;
    }

    const sectionRect = targetSection.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    const headerRect = header.getBoundingClientRect();
    const sectionVisible = sectionRect.bottom > 0 && sectionRect.top < window.innerHeight;
    const hasReachedHeader = sectionRect.top <= headerRect.bottom;
    const footerVisible = footerRect.top < window.innerHeight && footerRect.bottom > 0;

    if (sectionVisible && hasReachedHeader && !footerVisible) {
      navBar.classList.add("navScrolled");
      scrollElm?.classList.add("collection_left_new1");
      navBarText?.classList.add("filtertitle");
      productGrid?.classList.add("blokmargin");
    } else {
      navBar.classList.remove("navScrolled");
      scrollElm?.classList.remove("collection_left_new1");
      navBarText?.classList.remove("filtertitle");
      productGrid?.classList.remove("blokmargin");
    }
  }

  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
}

document.addEventListener("DOMContentLoaded", stickyFilter);

function countPlpGridProducts(root) {
  return Array.from((root || document).querySelectorAll('#product-grid > li.grid__item')).filter((li) => {
    return !li.classList.contains('colletion-verticle-banner') && !li.classList.contains('color-swatch-wrapper');
  }).length;
}

async function updateVisiblePlpProductCount() {
  const el = document.getElementById('ProductCountDesktop');
  if (!el || el.dataset.plpSizeFilter !== 'true') return;

  const pages = Number(el.dataset.plpPages || 1);
  const current = Number(el.dataset.plpPage || 1);
  const sectionId = el.dataset.plpSection;
  let total = countPlpGridProducts(document);

  if (pages > 1 && sectionId) {
    const fetches = [];
    for (let page = 1; page <= pages; page += 1) {
      if (page === current) continue;
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      fetches.push(
        fetch(url.toString())
          .then((response) => response.text())
          .then((html) => countPlpGridProducts(new DOMParser().parseFromString(html, 'text/html')))
          .catch(() => 0)
      );
    }
    const rest = await Promise.all(fetches);
    total += rest.reduce((sum, count) => sum + count, 0);
  }

  if (/\d/.test(el.textContent || '')) {
    el.textContent = el.textContent.replace(/\d+/, String(total));
  }
  const mobile = document.getElementById('ProductCount');
  if (mobile && /\d/.test(mobile.textContent || '')) {
    mobile.textContent = mobile.textContent.replace(/\d+/, String(total));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateVisiblePlpProductCount);
} else {
  updateVisiblePlpProductCount();
}